import { render, staticRenderFns } from "./MayaSuccessPageComponent.vue?vue&type=template&id=0db7fc55&scoped=true&"
import script from "./MayaSuccessPageComponent.vue?vue&type=script&lang=js&"
export * from "./MayaSuccessPageComponent.vue?vue&type=script&lang=js&"
import style0 from "./MayaSuccessPageComponent.vue?vue&type=style&index=0&id=0db7fc55&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db7fc55",
  null
  
)

export default component.exports